<template>
  <div class="shopCardList" style="width: 100%; display: block; box-shadow: none">
    <div style="position: relative">
      <div style="margin: 0;width: 100%;height: 100%;display: flex;align-items: center">
      <div style="position: relative; width: 19.2vw; height: 19.2vw; display: inline-block;border-radius: .8vw; overflow: hidden">
<!--        <div v-if="!row.totalStock || row.totalStock < 0" class="centerBox" style=" position: absolute; top: 0; bottom: 0;width: 100%;background-color: rgba(255, 255 ,255 , .5); z-index: 10">-->
<!--          <img src="../../assets/img/wuhuo1.png" style="width: 50%; opacity: .9;">-->
<!--        </div>-->
        <div style="background-color: #ffffff; height: 100%; width: 100%">
          <img :src="row.goodsImg || row.imgPath" style="width: 100%; height: 100%; -webkit-touch-callout: none; -webkit-user-select: none; user-select: none;">
        </div>
      </div>
      <div class="shopListInfo">
        <div style="font-size: 3.73vw; width: 55vw; margin-top: .8vw;font-weight: bold">
          {{row.goodsName}}
<!--          精品红油-->
        </div>
        <div style="justify-content: left;margin: 1vw 0;color: #9f9f9f;font-size: 2.67vw">
          {{row.specification || ''}}
        </div>
        <div style="justify-content: left;margin: 0;color: #9f9f9f;font-size: 2.67vw">
          单价: {{row.unitPrice / 100 || 0}}
          <span style="margin-left: 2vw">袋数: {{row.specificationQty}}</span>
          <span style="margin-left: 2vw">价格/件: {{$utils.priceFormat(row.price)}}</span>
        </div>
        <div  class="shopCardMoney" style="margin-bottom: 0;line-height: 5.33vw;">
          <div v-if="!source">
            <span style="font-size: 3.47vw;letter-spacing: -.3vw;">￥</span><span style="font-size: 5.33vw;font-weight: bold">{{$utils.priceFormat(row.price)}}</span>
          </div>
          <div v-if="source">
            <span style="font-size: 3.47vw;letter-spacing: -.3vw;">￥</span><span style="font-size: 5.33vw;font-weight: bold">{{(row.unitPrice * row.buyQty)/100}}</span>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="addButton" @click.stop @click="changeShop(row)">-->
<!--      <img :src="icon.addButton" style="width: 3.73vw">-->
<!--    </div>-->
<!--    <div @click="expend(row)" style="position: absolute;bottom: .9vw;right: 3.5vw;width: 4vw;height: 4vw">-->
<!--      <van-icon v-show="!row.show" color="#666" style="font-size: 4vw" name="arrow-down" />-->
<!--      <van-icon v-show="row.show" color="#666" style="font-size: 4vw" name="arrow-up" />-->
<!--    </div>-->
    <div style="position: absolute; right: 4.8vw;bottom: 1.1vw;" class="shopListStepper">
      <van-stepper
              v-model="row.buyQty"
              input-width="6.67vw"
              :step="row.miniBuyQty"
              button-size="3.73vw"
              integer
              v-if="row.buyQty"
              disable-input
              @plus="changePlus(row)"
              @minus="changMinus(row)"
              :min="min || 0">
      </van-stepper>
        <div class="addButton" style="bottom: 0vw;right: 0vw" v-else @click.stop @click="changePlus(row)">
          <img :src="icon.addButton" style="width: 3.73vw">
        </div>
    </div>
    </div>
    <div style="width: 100%">
<!--      分类附属品 加修改订单-->
<!--      <span v-if="row.minGoodsList && row.minGoodsList[0] !== null && row.show" style="font-weight: 700">关联商品</span>-->
<!--      <div v-if="row.minGoodsList && row.minGoodsList[0] !== null && row.show">-->
<!--        <div v-for="item in row.minGoodsList" :key="item.id" style="width: 100%;height: 8vw;line-height: 8vw;position: relative;margin: 2vw 0 0">-->
<!--          <span style="width: 8vw;height: 8vw;display: inline-block;position: absolute;top: 0vw">-->
<!--            <img v-if="item.goodsImg || item.imgPath" :src="item.goodsImg || item.imgPath" style="width: 100%;height: 100%">-->
<!--          </span>-->
<!--          <span style="font-weight: 700;font-size: 3vw;margin-left: 10vw;width: 32vw;display: inline-block;overflow: hidden;display: inline-block;height: 7vw">{{item.goodsName}}</span>-->
<!--          <span style="font-weight: 700;font-size: 3vw;position: absolute;left: 46vw">￥{{item.price/100}}</span>-->
<!--          <div style="position: absolute; right: 4.8vw;bottom: 0vw;" class="shopListStepper">-->
<!--            <van-stepper-->
<!--              v-model="item.buyQty"-->
<!--              input-width="6.67vw"-->
<!--              button-size="3.73vw"-->
<!--              integer-->
<!--              :step="item.miniBuyQty"-->
<!--              v-if="item.buyQty"-->
<!--              disable-input-->
<!--              @plus="changePlusTwo(item, row)"-->
<!--              @minus="changMinusTwo(item, row)"-->
<!--              :min="min || 0">-->
<!--            </van-stepper>-->
<!--            <div style="position: absolute;bottom: 3.3vw;right: 0vw;width: 4vw;height: 4vw" v-else @click.stop @click="changePlusTwo(item, row)">-->
<!--              <img :src="icon.addButton" style="width: 3.73vw">-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      购物车附属品-->
<!--      <span v-if="row.minCartGoodsList && row.minCartGoodsList.length > 0 && row.show" style="font-weight: 700">关联商品</span>-->
<!--      <div v-if="row.minCartGoodsList && row.minCartGoodsList.length > 0 && row.show">-->
<!--        <div v-for="item in row.minCartGoodsList" :key="item.id" style="width: 100%;height: 8vw;line-height: 8vw;position: relative;margin: 2vw 0 0">-->
<!--        <span style="width: 8vw;height: 8vw;display: inline-block;position: absolute;top: 0vw;">-->
<!--          <img v-if="item.goodsImg || item.imgPath" :src="item.goodsImg || item.imgPath" style="width: 100%;height: 100%">-->
<!--        </span>-->
<!--        <span style="font-weight: 700;font-size: 3.7vw;position: absolute;left: 10vw;width: 32vw;overflow: hidden;display: inline-block;height: 7vw">{{item.goodsName}}</span>-->
<!--        <span style="font-weight: 700;font-size: 3vw;position: absolute;left: 46vw">￥{{(item.unitPrice * item.qty)/100}}</span>-->
<!--        <div style="position: absolute; right: 4.8vw;bottom: 0vw;" class="shopListStepper">-->
<!--          <van-stepper-->
<!--            v-model="item.qty"-->
<!--            input-width="6.67vw"-->
<!--            button-size="3.73vw"-->
<!--            integer-->
<!--            :step="item.miniBuyQty"-->
<!--            v-if="item.qty"-->
<!--            disable-input-->
<!--            @plus="changePlusTwo(item, row)"-->
<!--            @minus="changMinusTwo(item, row)"-->
<!--            min="0">-->
<!--          </van-stepper>-->
<!--          <div style="position: absolute;bottom: 3.3vw;right: 0vw;width: 4vw;height: 4vw" v-else @click.stop @click="changePlusTwo(item, row)">-->
<!--            <img :src="icon.addButton" style="width: 3.73vw">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import addButton from '../../assets/img/icon/addButton.png'
import { ImagePreview } from 'vant'
export default {
  name: 'index',
  props: {
    row: Object,
    min: Number,
    source: Number
  },
  data () {
    return {
      icon: {
        addButton
      }
    }
  },
  methods: {
    expend (item) {
      this.$emit('expend', item)
    },
    toInfo (id) {
      this.$emit('toInfo', id)
    },
    changeShop (item) {
      this.$emit('changeShop', item)
    },
    changePlus (item) {
      this.$emit('plus', item)
    },
    changMinus (item) {
      this.$emit('minus', item)
    },
    changePlusTwo (item, row) {
      this.$emit('plusTwo', item, row)
    },
    changMinusTwo (item, row) {
      this.$emit('minusTwo', item, row)
    },
    showImg (img) {
      ImagePreview({
        images: [
          img
        ],
        closeable: true
      })
    }
  }
}
</script>

<style scoped>

</style>
